import RichEditor from "./RichEditor";

export default RichEditor;
